/* ==================================================
  Product Gallery
================================================== */

const initProductGallery = () => {  

  const carousel = new Splide('#product-gallery', {    
    perPage: 1,
    perMove: 1,    
    pagination: true,
    arrows: false,
    mediaQuery: 'min',
    breakpoints: {
      1024: {
        pagination: false,
      }
    }
  })
  
  var myElem = document.getElementById('product-thumbnails');
  if (myElem != null) {

    const thumbnailNav = new Splide( '#product-thumbnails', {
      fixedWidth: 90,
      fixedHeight: 100,
      gap: 10,
      rewind: true,
      pagination: false,
      arrows: false,
      isNavigation: true
    })
    carousel.sync( thumbnailNav )
    thumbnailNav.mount()

  }

  carousel.mount()
  
}
window.addEventListener('load', () => { initProductGallery() })


/* ==================================================
  Testimonials
================================================== */

const initTestimonialsCarousel = () => {    
  const testimonialsCarousel = document.querySelectorAll('.testimonials-slider')
  if(testimonialsCarousel.length) {
    testimonialsCarousel.forEach((item) => {
      const carousel = new Splide(item, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        pagination: false,
        arrows: true
      })      
      carousel.mount()
    })
  }
}
window.addEventListener('load', () => { initTestimonialsCarousel() })